export default class DateFormatHelper {
  static fromDbFormatToJsFormat(dbFormat) {
    let jsFormats = {
      fullFormat: false,
      dateFormat: false,
      timeFormat: false
    };

    jsFormats.fullFormat = this.replaceAll(
      dbFormat,
      this.patternMap
    );

    // Date and time
    if (dbFormat.indexOf(" ") !== -1) {
      let splittedFormats = dbFormat.split(" ");
      if (splittedFormats.length === 2) {
        for (let splittedFormat of splittedFormats) {
          if (this.containsDbDate(splittedFormat)) {
            jsFormats.dateFormat = splittedFormat;
          } else if (this.containsDbTime(splittedFormat)) {
            jsFormats.timeFormat = splittedFormat;
          }
        }
      }
    } else {
      if (this.containsDbDate(dbFormat)) {
        // Only date
        jsFormats.dateFormat = dbFormat;
      } else if (this.containsDbTime(dbFormat)) {
        // Only time
        jsFormats.timeFormat = dbFormat;
      }
    }

    if (jsFormats.timeFormat !== false) {
      jsFormats.timeFormat = this.replaceAll(
        jsFormats.timeFormat,
        this.patternMap
      );
    }

    return jsFormats;
  }

  static containsDbDate(str) {
    return (
      str.indexOf("D") !== -1 ||
      str.indexOf("MM") !== -1 ||
      str.indexOf("Y") !== -1
    );
  }

  static containsDbTime(str) {
    return (
      str.indexOf("HH") !== -1 ||
      str.indexOf("MI") !== -1 ||
      str.indexOf("SS") !== -1
    );
  }

  static get patternMap() {
    return {
      HH24: "HH",
      HH12: "hh",
      HH: "hh",
      MI: "mm",
      SS: "ss"
    }
  };

  static replaceAll(str, patternMap) {
    const searchValue = new RegExp(
      "\\b(?:" + Object.keys(patternMap).join("|") + ")\\b",
      "gi"
    );

    return str.replace(searchValue, (matched) => {
      return patternMap[matched];
    });
  }
}
